export const kMedianClass = "median"
export const kMedianType = "Median"
export const kMedianPrefix = "ADRN"
export const kMedianLabelKey = "DG.Inspector.graphPlottedMedian"
export const kMedianUndoAddKey = "DG.Undo.graph.showPlottedMedian"
export const kMedianRedoAddKey = "DG.Redo.graph.showPlottedMedian"
export const kMedianUndoRemoveKey = "DG.Undo.graph.hidePlottedMedian"
export const kMedianRedoRemoveKey = "DG.Redo.graph.hidePlottedMedian"
export const kMedianValueTitleKey = "DG.PlottedAverageAdornment.medianValueTitle"
